<template>
  <v-app>
    <v-navigation-drawer
      v-if="user"
      dark
      style="background:#af1c2e"
      :clipped="$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      fixed
      app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-list-tile :key="item.text" @click="navigate(item.route)">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <v-list-tile @click="$store.dispatch('logout')">
          <v-list-tile-action>
            <v-icon>lock</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Logout
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      v-if="user"
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      dark
      style="background:#af1c2e"
      app
      fixed
      dense
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"/>
      <v-toolbar-title v-text="title"/>
      <v-spacer/>
    </v-toolbar>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
  import { mapGetters } from "vuex";
  import {auth} from './firebase.js'

  export default {
    computed: {
      ...mapGetters(["user"])
    },
    name: "App",
    data () {
      return {
        clipped: false,
        drawer: false,
        fixed: false,
        items: [
          {
            icon: "event",
            title: "Appointment Calendar",
            route: "/appointments"
          }
        ],
        miniVariant: false,
        right: true,
        rightDrawer: false,
        title: "Braziers"
      };
    },
    mounted() {
      this.$store.dispatch("loadAllTenants");
      auth.onAuthStateChanged(user => {
        if (user) {
          this.$store.dispatch('autoSignIn', user)
        }
      })
    },
    methods: {
      navigate (route) {
        this.$router.push(route);
      }
    }
  };
</script>
